<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <DepartmentListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import DepartmentListing from "@/views/pages/admin/department/departmentListing";

export default {
    page: {
        title: i18n.t("module.department"),
    },
    components: { Layout, PageHeader, DepartmentListing },
    data() {
        return {
            title: i18n.t("module.department"),
            items: [
                {
                    text: i18n.t("module.workplace"),
                    href: '/workplaces',
                },
                {
                    text: i18n.t("module.department"),
                    active: true,
                },
            ],
        };
    },
}
</script>
